import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import { store } from './state/store';
import { LanguageProvider } from './context/LanguageContext';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { queryClient } from './config/queryClient';
import { clearExpiredCache } from './utils/localStorage';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import './index.css';

// Clear expired cache on app startup
clearExpiredCache();

const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <LanguageProvider>
          <App />
          {process.env.NODE_ENV === 'development' && (
            <ReactQueryDevtools initialIsOpen={false} />
          )}
        </LanguageProvider>
      </Provider>
    </QueryClientProvider>
  </React.StrictMode>
);

// Unregister service worker to disable offline functionality
serviceWorkerRegistration.unregister();